import styles from './index.module.scss';
import { PropType, defineComponent, h } from 'vue';
import { Gap } from '..';

export type Separator =
    'none'
    | 'border';

export const Sections = defineComponent({
    props: {
        gap: {
            required: false,
            type: String as PropType<Gap>,
            default: 'normal',
        },

        as: {
            required: false,
            type: String,
            default: 'div',
        },

        separator: {
            required: false,
            type: String as PropType<Separator>,
            default: 'none',
        },
    },

    render() {
        return h(this.as, {
            class: {
                sections: true,
                [styles.sections]: true,
                [styles.normal]: this.gap === 'normal',
                [styles.tight]: this.gap === 'tight',
                [styles.tighter]: this.gap === 'tighter',
                [styles.wide]: this.gap === 'wide',
                [styles.wider]: this.gap === 'wider',
                [styles.extra_wide]: this.gap === 'extra-wide',
                [styles.border]: this.separator === 'border',
            },
        }, this.$slots.default ? this.$slots.default() : '');
    }
});
